import { render, staticRenderFns } from "./statusChart.vue?vue&type=template&id=0d0fed36"
import script from "./statusChart.vue?vue&type=script&lang=ts"
export * from "./statusChart.vue?vue&type=script&lang=ts"
import style0 from "./statusChart.vue?vue&type=style&index=0&id=0d0fed36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports